import React from 'react'
import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import { getReplyValue, findReplyByQuestionId } from '../../_helpers/pdfHelpers'
import { formatDate } from '@btime/helpers'

const footer = [
  { text: 'Rua: Antônio Borges 172, Jardim Chapadão, Campinas - SP' },
  {
    text: 'Telefone: ',
    links: [
      { href: 'tel:1941071003', label: '19-4107-1003' },
      { href: 'tel:1992567950', label: ' / 19-9256-7950' },
      { href: 'tel:1996950260', label: ' / 19-9695-0260' },
      { href: 'tel:1998829819', label: ' / 19-9882-9819' }
    ]
  },
  {
    text: 'E-mail: ',
    links: [
      { href: 'mailto:comercial2@easysolution.net.br', label: 'comercial2@easysolution.net.br' },
      { href: 'mailto:eduardo@easysolution.net.br', label: ' / eduardo@easysolution.net.br' },
      { href: 'mailto:henrique@easysolution.net.br', label: ' / henrique@easysolution.net.br' }
    ]
  },
  {
    text: 'Site: ',
    links: [{ href: 'http://easysolutionservicos.com.br', label: 'http://easysolutionservicos.com.br' }]
  }
]

const Footer = () => {
  return (
    <>
      <Separator weight={10} />
      {footer.map((item, i) => (
        <div key={i} style={{ fontSize: 12, fontFamily: 'Arial, sans-serif', textAlign: 'justify', marginTop: 2 }}>
          {item.text}
          {item.links?.map((link, j) => (
            <a
              key={j}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'blue', textDecoration: 'underline' }}
            >
              {link.label}
            </a>
          ))}
        </div>
      ))}
    </>
  )
}

export default Footer
